// extracted by mini-css-extract-plugin
module.exports = {"vxca9tb":"vxca9tb"};